<ng-progress color="red" [thick]="true" [spinner]="false" [trickleSpeed]="500" [ease]="'easeInSine'" (started)="ngProgress.startedClass" (completed)="ngProgress.endedClass"></ng-progress>
<div class="page-contents">
  <div class="subBlockContainer" *ngIf="!narrowMode">
    <div class="breadcrumbWrapper">
      <app-breadcrumb></app-breadcrumb>
    </div>
    <div id="myAccount" class="subBlockContent">
      <child-header [title]="title" (closeEvent)="navigateTo('/home')"></child-header>
      <div class="child-body">
        <div class="item-title-wrapper">
          <!-- <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" [routerLink]="['/home']">close</i> -->
          <div class="page-title-description">Your Account Dashboard provides you with access to some of the
            information we know about you. It also has some handy quick links below that you can use to setup more
            functionality with us to make your ordering process more seamless. As your company grows and changes,
            please make sure you keep this section up to date so we can make sure we’re doing everything we can to
            look after you.</div>
          <div class="top-divider"></div>
          <div class="row">
            <div class="col-md-6">
              <div class="infoSection infoSection-detailBox-padding shadow-wrapper">
                <loading-icon [currentLoadingStatus]="summaryLoadingStatus"></loading-icon>
                <div class="infoSection-title-bold" *ngIf="!summaryLoadingStatus">{{companyInfo?.companyName}}</div>
                <div class="row infowrapper" *ngIf="!summaryLoadingStatus">
                  <div class="section-divider col-md-6" *ngIf="companyInfo?.abn">
                    <div>ABN</div>
                    <div>{{companyInfo?.abn}}</div>
                  </div>
                  <div class="section-divider col-md-6" *ngIf="companyInfo?.accountCode">
                    <div>DICKER DATA ACCOUNT CODE</div>
                    <div>{{companyInfo?.accountCode}}</div>
                  </div>
                  <div class="section-divider col-md-6" *ngIf="companyInfo?.phone">
                    <div>Phone</div>
                    <div>{{companyInfo?.phone}}</div>
                  </div>



                  <div class="section-divider col-md-6"
                    *ngIf="companyInfo?.addressLine || companyInfo?.addressLine2 ||companyInfo?.suburb || companyInfo?.state || companyInfo?.postcode">
                    <div>ADDRESS</div>
                    <div class="addressFormat">{{companyInfo?.addressLine}}, {{companyInfo?.addressLine2}}</div>
                    <div>{{companyInfo?.suburb[0].toUpperCase() + companyInfo?.suburb.slice(1).toUpperCase()}}
                      {{companyInfo?.state}} {{companyInfo?.postcode}}</div>
                  </div>
                  <div class="section-divider col-md-6" *ngIf="companyInfo?.website">
                    <div>WEBSITE</div>
                    <div>{{companyInfo?.website}}</div>
                  </div>
                  <div class="section-divider col-md-6" *ngIf="companyInfo?.mainContact">
                    <div>MAIN CONTACT</div>
                    <div>{{companyInfo?.mainContact}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="infoSection infoSection-detailBox-padding shadow-wrapper">
                <div class="infoSection-title-bold">TRANSACTIONAL SUMMARY</div>
                <loading-icon [currentLoadingStatus]="chartLoadingStatus"></loading-icon>
                <div class="row" [hidden]="chartLoadingStatus">
                  <canvas #chartTransactionSummary id="chartTransactionSummary" width="440" height="220"></canvas>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="inner-subBlock-wrapper">
          <div class="page-main-wrapper">
            <div class="row">
              <div class="col-lg-4 row-eq-height">
                <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                  <div class="infoSection-title">Company Information</div>
                  <div class="infoSection-content">Keep all of the information we store about your company up to
                    date here</div>
                  <ul class="list-group list-group-flush">
                    <ng-container *ngIf="authService.menuLoadingCompleted && !hasCustomersMenu()">
                      <li *ngFor="let item of companyInfoMenu" class="list-group-item" [routerLink]="item.menuRouter"
                        (click)="changeMode($event);">
                        <span class="small-logo-wrapper">
                          <img [src]="item.menuIconUrl">
                        </span>
                        &nbsp;&nbsp;{{item.menuName}}
                      </li>
                    </ng-container>
                    <ng-container *ngIf="authService.menuLoadingCompleted && hasCustomersMenu()">
                      <li *ngFor="let item of companyInfoMenu2" class="list-group-item" [routerLink]="item.menuRouter"
                        (click)="changeMode($event);">
                        <span class="small-logo-wrapper">
                          <img [src]="item.menuIconUrl">
                        </span>
                        &nbsp;&nbsp;{{item.menuName}}
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </div>
              <div class="col-lg-4 row-eq-height">
                <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                  <div class="infoSection-title">Finance</div>
                  <div class="infoSection-content">Check your account status here or set up payment methods to
                    make online ordering faster</div>
                  <ul class="list-group list-group-flush">
                    <ng-container *ngIf="authService.menuLoadingCompleted && !hasCustomersMenu()">
                      <li *ngFor="let item of financeMenu" class="list-group-item" [routerLink]="item.menuRouter"
                        (click)="changeMode($event);">
                        <span class="small-logo-wrapper">
                          <img [src]="item.menuIconUrl">
                        </span>
                        &nbsp;&nbsp;{{item.menuName}}
                      </li>
                    </ng-container>
                    <ng-container *ngIf="authService.menuLoadingCompleted && hasCustomersMenu()">
                      <li *ngFor="let item of financeMenu2" class="list-group-item" [routerLink]="item.menuRouter"
                        (click)="changeMode($event);">
                        <span class="small-logo-wrapper">
                          <img [src]="item.menuIconUrl">
                        </span>
                        &nbsp;&nbsp;{{item.menuName}}
                      </li>
                    </ng-container>
                  </ul>
                </div>
              </div>
              <div class="col-lg-4 row-eq-height" *ngIf="hasAdminAccess == true">
                <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                  <div class="infoSection-title">Portal Access</div>
                  <div class="infoSection-content">Control who from your company can access our website and place
                    orders with us</div>
                  <ul class="list-group list-group-flush">
                    <li *ngFor="let item of portalMenu" class="list-group-item" [routerLink]="item.menuRouter"
                      (click)="changeMode($event);">
                      <span class="small-logo-wrapper">
                        <img [src]="item.menuIconUrl">
                      </span>
                      &nbsp;&nbsp;{{item.menuName}} </li>
                  </ul>
                </div>
              </div>
              <!-- <div class="col-lg-4 row-eq-height" *ngIf="integrationNMenu.length !== 0 && (showApiBox || currentUserModel?.isStaffAccount)"> -->
              <div class="col-lg-4 row-eq-height" *ngIf="integrationNMenu.length !== 0 && currentUserModel?.hasAdminAccess && authService.menuLoadingCompleted && !hasCustomersMenu()">
                <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                  <div class="infoSection-title">Integration</div>
                  <div class="infoSection-content">Get connected with Dicker Data’s API suite to automate your
                    ordering process</div>
                  <ul class="list-group list-group-flush">
                    <li *ngFor="let item of integrationNMenu" class="list-group-item" [routerLink]="item.menuRouter"
                      (click)="changeMode($event);">
                      <span class="small-logo-wrapper">
                        <img [src]="item.menuIconUrl">
                      </span>
                      &nbsp;&nbsp;{{item.menuName}} </li>
                  </ul>
                </div>
              </div>
              <div class="col-lg-4 row-eq-height">
                <div class="infoSection infoSection-infoBox-padding shadow-wrapper">
                  <div class="infoSection-title">Transactions</div>
                  <div class="infoSection-content">Return an order using our online process</div>
                  <ul class="list-group list-group-flush">
                    <ng-container *ngIf="authService.menuLoadingCompleted && !hasCustomersMenu()">
                      <li *ngFor="let item of orderMenu" class="list-group-item" [routerLink]="item.menuRouter"
                        (click)="changeMode($event);">
                        <span class="small-logo-wrapper">
                          <img [src]="item.menuIconUrl">
                        </span>
                        &nbsp;&nbsp;{{item.menuName}}
                      </li>
                    </ng-container>
                    <ng-container *ngIf="authService.menuLoadingCompleted && hasCustomersMenu()">
                      <li *ngFor="let item of orderMenu2" class="list-group-item" [routerLink]="item.menuRouter"
                      (click)="changeMode($event);">
                      <span class="small-logo-wrapper">
                        <img [src]="item.menuIconUrl">
                      </span>
                      &nbsp;&nbsp;{{item.menuName}}
                    </li>
                    </ng-container>

                  </ul>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>

  <div class="subBlockContainer"  *ngIf="narrowMode">
    <div class="breadcrumbWrapper">
      <app-breadcrumb></app-breadcrumb>
    </div>

    <div class="blockContainer narrow-sidebar subBlockContainer_toplevel" id="levelOne" >


    <div class="combination-loader">
      <div class="child-sidebar sidebar-loader">
        <child-header [title]="title" (closeEvent)="close()" ></child-header>
        <!-- <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div> -->
        <div class="child-body myaccount-mini">
          <div class="infoSection-title" id="first-title">COMPANY INFORMATION</div>
          <ng-container *ngIf="authService.menuLoadingCompleted && !hasCustomersMenu()">
            <ng-container *ngFor="let item of companyInfoMenu">
              <div class="menu-wrapper menu-font" [id]="item.menuRouter" [routerLink]="item.menuRouter"
                routerLinkActive="active">
                <span class="small-logo-wrapper">
                  <img [src]="item.menuIconUrl">
                </span>
                &nbsp;
                {{item.menuName}}
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="authService.menuLoadingCompleted && hasCustomersMenu()">
            <ng-container *ngFor="let item of companyInfoMenu2">
              <div class="menu-wrapper menu-font" [id]="item.menuRouter" [routerLink]="item.menuRouter"
                routerLinkActive="active">
                <span class="small-logo-wrapper">
                  <img [src]="item.menuIconUrl">
                </span>
                &nbsp;
                {{item.menuName}}
              </div>
            </ng-container>
          </ng-container>


          <div class="infoSection-title">FINANCE</div>
          <ng-container *ngIf="authService.menuLoadingCompleted && !hasCustomersMenu()">
            <ng-container *ngFor="let item of financeMenu">
              <div class="menu-wrapper menu-font" [id]="item.menuRouter" [routerLink]="item.menuRouter"
                routerLinkActive="active">
                <span class="small-logo-wrapper">
                  <img [src]="item.menuIconUrl">
                </span>
                &nbsp;
                {{item.menuName}}
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="authService.menuLoadingCompleted && hasCustomersMenu()">
            <ng-container *ngFor="let item of financeMenu2">
              <div class="menu-wrapper menu-font" [id]="item.menuRouter" [routerLink]="item.menuRouter"
                routerLinkActive="active">
                <span class="small-logo-wrapper">
                  <img [src]="item.menuIconUrl">
                </span>
                &nbsp;
                {{item.menuName}}
              </div>
            </ng-container>
          </ng-container>

          <div *ngIf="hasAdminAccess">
            <div class="infoSection-title">PORTAL ACCESS</div>
            <ng-container *ngFor="let item of portalMenu">
              <div class="menu-wrapper menu-font" [id]="item.menuRouter" [routerLink]="item.menuRouter"
                routerLinkActive="active">
                <span class="small-logo-wrapper">
                  <img [src]="item.menuIconUrl">
                </span>
                &nbsp;
                {{item.menuName}}
              </div>
            </ng-container>
          </div>

          <!-- <div *ngIf="showApiBox || currentUserModel?.isStaffAccount"> -->
          <div *ngIf="currentUserModel?.hasAdminAccess && authService.menuLoadingCompleted && !hasCustomersMenu()">
            <div class="infoSection-title" *ngIf="integrationNMenu.length !== 0">INTEGRATION</div>
            <ng-container *ngFor="let item of integrationNMenu">
              <div class="menu-wrapper menu-font" [id]="item.menuRouter" [routerLink]="item.menuRouter"
                routerLinkActive="active">
                <span class="small-logo-wrapper">
                  <img [src]="item.menuIconUrl">
                </span>
                &nbsp;
                {{item.menuName}}
              </div>
            </ng-container>
          </div>

          <div class="infoSection-title">Transactions</div>
          <ng-container *ngIf="authService.menuLoadingCompleted && !hasCustomersMenu()">
            <ng-container *ngFor="let item of orderMenu">
              <div class="menu-wrapper menu-font" [id]="item.menuRouter" [routerLink]="item.menuRouter"
                routerLinkActive="active">
                <span class="small-logo-wrapper">
                  <img [src]="item.menuIconUrl">
                </span>
                &nbsp;
                {{item.menuName}}
              </div>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="authService.menuLoadingCompleted && hasCustomersMenu()">
            <ng-container *ngFor="let item of orderMenu2">
              <div class="menu-wrapper menu-font" [id]="item.menuRouter" [routerLink]="item.menuRouter"
                routerLinkActive="active">
                <span class="small-logo-wrapper">
                  <img [src]="item.menuIconUrl">
                </span>
                &nbsp;
                {{item.menuName}}
              </div>
            </ng-container>
          </ng-container>

        </div>
      </div>

      <div class="child-loader">
        <router-outlet></router-outlet>
      </div>

    </div>

    </div>
  </div>

</div>
